import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

    static targets = [ "controlInput", "dependentInput" ]

    connect() {
        this.toggleDependentInput();
        this.controlInputTarget.addEventListener("change", this.toggleDependentInput.bind(this));
    }

    toggleDependentInput() {
        if (this.controlInputTarget.checked) {
            this.dependentInputTargets.forEach((dependentInput) => {
                dependentInput.removeAttribute("disabled");
            }
            );
        } else {
            this.dependentInputTargets.forEach((dependentInput) => {
                dependentInput.setAttribute("disabled", "disabled");
            }
            );
        }
    }

}